// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__jcCJJ","lined":"Button_lined__U8yx4"};